<template>
	<button class="view-ui-button-continue button-primary" v-on:click="$emit('continue')">Continue</button>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Button
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiButtonContinue extends ViewBase {
		// Not implemented
	}
</script>
